import { TypeList } from './TypeList'
import { TypeCreate } from './TypeCreate'
import { TypeEdit } from './TypeEdit'

export { TypeList, TypeCreate, TypeEdit }


// WEBPACK FOOTER //
// ./src/components/type/index.js